export const MAX_RESULTS = 5
export const MAX_KEYWORDS = 3
export const BLACKLSITED_DOMAINS = [
  'www.linkedin.com',
  'www.yelp.com',
  'www.homeadvisor.com',
  'www.findlaw.com',
  'www.superlawyers.com',
  'www.expertise.com',
  'www.avvo.com',
  'www.lawyers.com',
  'comptroller.texas.gov',
  'www.justia.com',
  'justia.com',
  'attorneys.superlawyers.com',
];
export const DEV_API_URL = 'http://localhost:8085/api/'
export const PROD_API_URL = 'https://analytics-api.vercel.app/api/'
export const CALLBACK_API_URL = 'https://callback-api-reinislucis.otm.now.sh/api/'
export const SPREADSHEET_ID = '1z7LPXJo6x2wUQRIaUZClBGs2mbG73AaSsJ1iVZwsW_k'